import { create } from "zustand";

/**
 * Which section the visitor is currently exploring.
 *
 * Scoped to the browser session (sessionStorage), so the chooser appears on
 * each new visit but a page refresh does not re-ask. There are no accounts, so
 * there is nowhere else to keep this.
 */
const KEY = "crossborder.section";

const readSession = () => {
  try {
    return sessionStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
};

export const useExploreStore = create((set) => ({
  section: readSession(),
  setSection: (section) => {
    try {
      sessionStorage.setItem(KEY, section);
    } catch {
      /* storage unavailable — the gate simply reappears */
    }
    set({ section });
  },
  reset: () => {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
    set({ section: null });
  },
}));

export default useExploreStore;
